import { h, Host } from "@stencil/core";
/**
 * Displays a grey block to placehold loading text.
 */
export class EsLoadingText {
    constructor() {
        this.expectedLength = undefined;
        this.variance = undefined;
    }
    render() {
        const renderedLength = this.variance
            ? Math.floor(Math.random() * this.variance) + this.expectedLength
            : this.expectedLength;
        return h(Host, { key: '487ceb294adf350dd40b18c9f6551ec55a69c520', role: 'presentation' }, ' '.repeat(renderedLength));
    }
    static get is() { return "es-loading-text"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["es-loading-text.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["es-loading-text.css"]
        };
    }
    static get properties() {
        return {
            "expectedLength": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The expected loaded text length."
                },
                "attribute": "expected-length",
                "reflect": false
            },
            "variance": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Adds a random number of chars (up to the passed amount)"
                },
                "attribute": "variance",
                "reflect": false
            }
        };
    }
}
//# sourceMappingURL=es-loading-text.js.map
